export * from './alerts.service';
import { AlertsService } from './alerts.service';
export * from './answers.service';
import { AnswersService } from './answers.service';
export * from './attendanceRegisters.service';
import { AttendanceRegistersService } from './attendanceRegisters.service';
export * from './auth.service';
import { AuthService } from './auth.service';
export * from './certificates.service';
import { CertificatesService } from './certificates.service';
export * from './certificationBonuses.service';
import { CertificationBonusesService } from './certificationBonuses.service';
export * from './certificationCourses.service';
import { CertificationCoursesService } from './certificationCourses.service';
export * from './certificationFamilies.service';
import { CertificationFamiliesService } from './certificationFamilies.service';
export * from './certificationGroups.service';
import { CertificationGroupsService } from './certificationGroups.service';
export * from './certifications.service';
import { CertificationsService } from './certifications.service';
export * from './consoleManager.service';
import { ConsoleManagerService } from './consoleManager.service';
export * from './coursePaths.service';
import { CoursePathsService } from './coursePaths.service';
export * from './courseSummaryDocuments.service';
import { CourseSummaryDocumentsService } from './courseSummaryDocuments.service';
export * from './courses.service';
import { CoursesService } from './courses.service';
export * from './curricula.service';
import { CurriculaService } from './curricula.service';
export * from './curriculumOptions.service';
import { CurriculumOptionsService } from './curriculumOptions.service';
export * from './days.service';
import { DaysService } from './days.service';
export * from './devices.service';
import { DevicesService } from './devices.service';
export * from './editions.service';
import { EditionsService } from './editions.service';
export * from './enrollments.service';
import { EnrollmentsService } from './enrollments.service';
export * from './exemptions.service';
import { ExemptionsService } from './exemptions.service';
export * from './expertises.service';
import { ExpertisesService } from './expertises.service';
export * from './externalCertificationTests.service';
import { ExternalCertificationTestsService } from './externalCertificationTests.service';
export * from './externalCertificationTimes.service';
import { ExternalCertificationTimesService } from './externalCertificationTimes.service';
export * from './files.service';
import { FilesService } from './files.service';
export * from './finalReviews.service';
import { FinalReviewsService } from './finalReviews.service';
export * from './helps.service';
import { HelpsService } from './helps.service';
export * from './locationTypes.service';
import { LocationTypesService } from './locationTypes.service';
export * from './locations.service';
import { LocationsService } from './locations.service';
export * from './matrices.service';
import { MatricesService } from './matrices.service';
export * from './mediaLibraryObjects.service';
import { MediaLibraryObjectsService } from './mediaLibraryObjects.service';
export * from './multicourses.service';
import { MulticoursesService } from './multicourses.service';
export * from './networks.service';
import { NetworksService } from './networks.service';
export * from './news.service';
import { NewsService } from './news.service';
export * from './notes.service';
import { NotesService } from './notes.service';
export * from './offices.service';
import { OfficesService } from './offices.service';
export * from './onlineCourses.service';
import { OnlineCoursesService } from './onlineCourses.service';
export * from './paths.service';
import { PathsService } from './paths.service';
export * from './positions.service';
import { PositionsService } from './positions.service';
export * from './productSheets.service';
import { ProductSheetsService } from './productSheets.service';
export * from './questionCategories.service';
import { QuestionCategoriesService } from './questionCategories.service';
export * from './questions.service';
import { QuestionsService } from './questions.service';
export * from './quizResults.service';
import { QuizResultsService } from './quizResults.service';
export * from './reports.service';
import { ReportsService } from './reports.service';
export * from './rooms.service';
import { RoomsService } from './rooms.service';
export * from './satisfactionQuizzes.service';
import { SatisfactionQuizzesService } from './satisfactionQuizzes.service';
export * from './segments.service';
import { SegmentsService } from './segments.service';
export * from './targets.service';
import { TargetsService } from './targets.service';
export * from './teachers.service';
import { TeachersService } from './teachers.service';
export * from './teachingSocieties.service';
import { TeachingSocietiesService } from './teachingSocieties.service';
export * from './thirdPartyCompanies.service';
import { ThirdPartyCompaniesService } from './thirdPartyCompanies.service';
export * from './uploads.service';
import { UploadsService } from './uploads.service';
export * from './users.service';
import { UsersService } from './users.service';
export * from './utils.service';
import { UtilsService } from './utils.service';
export * from './websockets.service';
import { WebsocketsService } from './websockets.service';
export * from './ws.service';
import { WsService } from './ws.service';
export const APIS = [AlertsService, AnswersService, AttendanceRegistersService, AuthService, CertificatesService, CertificationBonusesService, CertificationCoursesService, CertificationFamiliesService, CertificationGroupsService, CertificationsService, ConsoleManagerService, CoursePathsService, CourseSummaryDocumentsService, CoursesService, CurriculaService, CurriculumOptionsService, DaysService, DevicesService, EditionsService, EnrollmentsService, ExemptionsService, ExpertisesService, ExternalCertificationTestsService, ExternalCertificationTimesService, FilesService, FinalReviewsService, HelpsService, LocationTypesService, LocationsService, MatricesService, MediaLibraryObjectsService, MulticoursesService, NetworksService, NewsService, NotesService, OfficesService, OnlineCoursesService, PathsService, PositionsService, ProductSheetsService, QuestionCategoriesService, QuestionsService, QuizResultsService, ReportsService, RoomsService, SatisfactionQuizzesService, SegmentsService, TargetsService, TeachersService, TeachingSocietiesService, ThirdPartyCompaniesService, UploadsService, UsersService, UtilsService, WebsocketsService, WsService];
